export const SETUP_APP = 'SETUP_APP';
export const SETUP_ACCOUNTS = 'SETUP_ACCOUNTS';
export const ADD_ACCOUNT = 'ADD_ACCOUNT';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const SETUP_CONNECTIONS = 'SETUP_CONNECTIONS';
export const ADD_CONNECTION = 'ADD_CONNECTION';
export const UPDATE_CONNECTION = 'UPDATE_CONNECTION';
export const DELETE_CONNECTION = 'DELETE_CONNECTION';
